import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';
import { IAttestationSubCommissionDetails, IAttestationSubCommissionsList } from 'components/models';
import { IAttestationSubCommissionsFilters } from 'components/reduxModels';

const initialState: State = {
    ascList: null,
    ascDetails: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setAsc(state, ascList: State['ascList']): State {
            return { ...state, ascList };
        },
        setAscDetails: (state, ascDetails: State['ascDetails']): State => ({ ...state, ascDetails }),
    },
    effects: (dispatch: any) => ({
        async getAscAsync(payload: IAttestationSubCommissionsFilters) {
            this.setAsc(await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getAttestationSubCommissions(
                    payload.acIds,
                    payload.regionIds,
                    payload.searchField,
                    payload.searchTerm,
                    payload.page,
                    payload.pageSize,
                    payload.sortOrder,
                    payload.sortField,
                ),
            ));
        },
        async getAscDetailsAsync(id: string) {
            this.setAscDetails(await apiConnector.execApi(
                dispatch,
                apiClient => apiClient.getAttestationSubCommission(id),
            ));
        },
    }),
});

interface State {
    ascList: IAttestationSubCommissionsList | null;
    ascDetails: IAttestationSubCommissionDetails | null;
}

interface GetAscListPayload {
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}
